import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'submodel',
  title: 'Sub-Models',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Sub-Model Name',
      type: 'string',
      validation: (rule: any) => rule.required(),
    }),
    defineField({
      name: 'years',
      title: 'Years',
      type: 'years',
    }),
  ],
  preview: {
    select: {
      name: 'name',
      years: 'years',
    },
    prepare({ name: title, years: subtitle }) {
      return { title, subtitle }
    },
  },
})